<template>
  <input-date
    aria-autocomplete="off"
    :class="[classList, { _state_error: hasError }]"
    :id="id"
    :locale="locale"
    :value="dateModel"
    @input="validateDate"
  />
</template>

<script>
import InputDate from '@/components/project/atoms/InputDate'
import { formatDate } from '@/utils'

export default {
  name: 'DatepickerFallback',
  components: {
    InputDate
  },
  props: {
    id: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    classList: {
      type: Array,
      required: false
    },
    locale: {
      type: String,
      required: false,
      default: 'pt-BR'
    },
    limitDate: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      dateModel: this.date,
      hasError: false
    }
  },
  watch: {
    date (value) {
      if (this.dateModel !== value) {
        this.dateModel = value
      }
    }
  },
  methods: {
    validateDate (event) {
      if (this.dateModel !== event) {
        this.dateModel = event
        const obj = {
          value: event,
          text: '',
          hasError: false
        }
        if ([null, undefined, ''].includes(event)) {
          this.hasError = false
        } else {
          if (event.length === 10) {
            const value = new Date(event)
            const limit = new Date(this.limitDate)
            if (
              isNaN(value.getTime()) ||
              value.getTime() < 0 ||
              (this.limitDate && value.toISOString() > limit.toISOString())
            ) {
              this.hasError = true
            } else {
              this.hasError = false
              obj.value = event
              obj.text = formatDate(this.locale, event)
            }
          } else {
            this.hasError = false
          }
        }
        obj.hasError = this.hasError
        this.$emit('changeDate', obj)
      }
    }
  }
}
</script>
